/* eslint-disable import/order */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FindStandardProductOptions, StandardProductApi } from 'api';

export const findStandardProduct = createAsyncThunk<
  any,
  FindStandardProductOptions,
  { rejectValue: { message: string } }
>(
  'standardProduct/findStandardProduct',
  async (options, { rejectWithValue }) => {
    try {
      return await StandardProductApi.find(options);
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findStandardDiaries = createAsyncThunk<
  any,
  {
    id: string;
    options: any;
  },
  { rejectValue: { message: string } }
>(
  'standardProduct/findStandardDiaries',
  async (params, { rejectWithValue }) => {
    try {
      return await StandardProductApi.findStandardDiaries(
        params.id,
        params.options
      );
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface StandardProductState {}

const initialState: StandardProductState = {};

const standardProductSlice = createSlice({
  name: 'standardProduct',
  initialState,
  reducers: {},
  // extraReducers: builder => {},
});

const { reducer: standardProductReducer } = standardProductSlice;

export default standardProductReducer;
